import { DATE_FORMATS, DATE_UNIT, DateUtils } from "shared/dateUtils";

const formatDateForFilter = (date) =>
  DateUtils.parse(date).format(DATE_FORMATS["YYYY-MM-DDThh:mm:ss"]);

export const getDateValuesForFilter = (startConciliationDate) => {
  const now = DateUtils.now();
  const currentYear = now.year();

  const firstYearCut = DateUtils.parse(`${currentYear}-05-01T00:00:00`);
  const secondYearCut = DateUtils.parse(`${currentYear}-11-01T00:00:00`);

  const endFilterDate = now.format(DATE_FORMATS["YYYY-MM-DDThh:mm:ss"]);

  if (startConciliationDate != null) {
    return {
      endFilterDate,
      startFilterDate: formatDateForFilter(startConciliationDate),
    };
  }

  if (now.isBefore(firstYearCut)) {
    return {
      endFilterDate,
      startFilterDate: formatDateForFilter(
        secondYearCut.clone().subtract(1, DATE_UNIT.YEAR)
      ),
    };
  }

  if (now.isBefore(secondYearCut)) {
    return {
      endFilterDate,
      startFilterDate: formatDateForFilter(firstYearCut),
    };
  }

  return {
    endFilterDate,
    startFilterDate: formatDateForFilter(secondYearCut),
  };
};

export const ALL_CATEGORIES_OPTION_VALUE = 0;

export const createCategoryOptions = (animalCategories = [], t) => {
  const allOption = {
    value: ALL_CATEGORIES_OPTION_VALUE,
    label: t("common:all-male").toUpperCase(),
  };

  const list = [allOption];

  animalCategories.forEach((item) => {
    list.push({
      value: item.IdCategoriaAnimal,
      label: item.Nome,
    });
  });

  return list;
};

export const getCategoriesFromConciliationData = (data) => {
  if (!data) return [];

  return data.map((dataItem) => ({
    IdCategoriaAnimal: dataItem.CategoriaAnimal.IdCategoriaAnimal,
    Nome: dataItem.CategoriaAnimal.Nome,
  }));
};

export const filterDataForSelectedCategory = (data, selectedCategoryId) => {
  if (selectedCategoryId === ALL_CATEGORIES_OPTION_VALUE || data.length === 0) {
    return data;
  }

  return data.filter(
    (item) => item.CategoriaAnimal.IdCategoriaAnimal === selectedCategoryId
  );
};

export const PAGE_TYPE = {
  DEFAULT: "default",
  PRINT: "print",
};

export const TABLE_TYPE = {
  SUMMARY: "summary",
  DETAILED: "detailed",
};

export const TABLE_COLUMNS = {
  CATEGORY: "category", // detailed table
  ORIGIN: "origin",
  INITIAL_STOCK: "initial-stock",
  ENTRY: "entry",
  EXIT: "exit",
  CATEGORY_CHANGE_IN: "category-change-in",
  CATEGORY_CHANGE_OUT: "category-change-out",
  BIRTHS: "births",
  DEATHS: "deaths",
  INTERFUSION_BALANCE: "interfusion-balance", // summary table
  INTERFUSION: "interfusion", // detailed table
  FINAL_STOCK: "final-stock",
  DIFFERENCE: "difference",
};

export const COLUMNS_WITHOUT_PORTAL_DATA = [
  TABLE_COLUMNS.CATEGORY_CHANGE_IN,
  TABLE_COLUMNS.CATEGORY_CHANGE_OUT,
  TABLE_COLUMNS.BIRTHS,
  TABLE_COLUMNS.DEATHS,
  TABLE_COLUMNS.DIFFERENCE,
];

export const DETAILS_MODAL_TABLE_COLUMNS = {
  OPERATION_TYPE: "operation-type",
  APP_PORTAL: "app-portal",
  PASTURE: "pasture",
  DATE: "date",
  AMOUNT: "amount",
  WEIGHT: "weight",
  USER: "user",
};

export const getSummaryTableColumns = (t) => [
  {
    id: TABLE_COLUMNS.ORIGIN,
    label: t("movements:origin"),
    field: "Origem",
  },
  {
    id: TABLE_COLUMNS.INITIAL_STOCK,
    label: t("movements:initial-stock"),
    field: "EstoqueInicial",
  },
  {
    id: TABLE_COLUMNS.ENTRY,
    label: t("movements:entry"),
    field: "Entrada",
  },
  {
    id: TABLE_COLUMNS.EXIT,
    label: t("movements:exit"),
    field: "Saida",
  },
  {
    id: TABLE_COLUMNS.CATEGORY_CHANGE_IN,
    label: t("movements:category-change-in"),
    field: "EntradaTrocaDeCategoria",
  },
  {
    id: TABLE_COLUMNS.CATEGORY_CHANGE_OUT,
    label: t("movements:category-change-out"),
    field: "SaidaTrocaDeCategoria",
  },
  {
    id: TABLE_COLUMNS.BIRTHS,
    label: t("movements:births"),
    field: "Nascimento",
  },
  {
    id: TABLE_COLUMNS.DEATHS,
    label: t("movements:deaths"),
    field: "Morte",
  },
  {
    id: TABLE_COLUMNS.INTERFUSION_BALANCE,
    label: t("movements:interfusion-balance"),
    field: "Entrevero",
  },
  {
    id: TABLE_COLUMNS.FINAL_STOCK,
    label: t("movements:final-stock"),
    field: "EstoqueFinal",
  },
  {
    id: TABLE_COLUMNS.DIFFERENCE,
    label: t("common:difference"),
    field: "Diferenca",
  },
];

export const getDetailedTableColumns = (t) => [
  {
    id: TABLE_COLUMNS.CATEGORY,
    label: t("animalCategory:category"),
    field: "CategoriaAnimal",
  },
  {
    id: TABLE_COLUMNS.ORIGIN,
    label: t("movements:origin"),
    field: "Origem",
  },
  {
    id: TABLE_COLUMNS.INITIAL_STOCK,
    label: t("movements:initial-stock"),
    field: "EstoqueInicial",
  },
  {
    id: TABLE_COLUMNS.ENTRY,
    label: t("movements:entry"),
    field: "Entrada",
  },
  {
    id: TABLE_COLUMNS.EXIT,
    label: t("movements:exit"),
    field: "Saida",
  },
  {
    id: TABLE_COLUMNS.CATEGORY_CHANGE_IN,
    label: t("movements:category-change-in"),
    field: "EntradaTrocaDeCategoria",
  },
  {
    id: TABLE_COLUMNS.CATEGORY_CHANGE_OUT,
    label: t("movements:category-change-out"),
    field: "SaidaTrocaDeCategoria",
  },
  {
    id: TABLE_COLUMNS.BIRTHS,
    label: t("movements:births"),
    field: "Nascimento",
  },
  {
    id: TABLE_COLUMNS.DEATHS,
    label: t("movements:deaths"),
    field: "Morte",
  },
  {
    id: TABLE_COLUMNS.INTERFUSION,
    label: t("movements:interfusion"),
    field: "Entrevero",
  },
  {
    id: TABLE_COLUMNS.FINAL_STOCK,
    label: t("movements:final-stock"),
    field: "EstoqueFinal",
  },
  {
    id: TABLE_COLUMNS.DIFFERENCE,
    label: t("common:difference"),
    field: "Diferenca",
  },
];

export const getDetailsModalTableColumns = (t) => [
  {
    id: DETAILS_MODAL_TABLE_COLUMNS.OPERATION_TYPE,
    label: t("movements:operation-type"),
  },
  {
    id: DETAILS_MODAL_TABLE_COLUMNS.APP_PORTAL,
    label: `${t("common:app")}/${t("common:portal")}`,
  },
  {
    id: DETAILS_MODAL_TABLE_COLUMNS.PASTURE,
    label: t("locales:pasture"),
  },
  {
    id: DETAILS_MODAL_TABLE_COLUMNS.DATE,
    label: t("common:fields.date"),
  },
  {
    id: DETAILS_MODAL_TABLE_COLUMNS.AMOUNT,
    label: t("common:amount"),
  },
  {
    id: DETAILS_MODAL_TABLE_COLUMNS.WEIGHT,
    label: t("livestock:weight"),
  },
  {
    id: DETAILS_MODAL_TABLE_COLUMNS.USER,
    label: t("common:fields.user"),
  },
];

export const COLORS = {
  GREEN: "#32A07D",
  GRAY: "#e1e1e1",
  RED: "#eb394c",
  VERY_LIGHT_GRAY: "#fafafa",
};

export const getStylesForDifferenceSummaryColumnCell = ({
  columnId,
  pageType,
  value,
}) => {
  if (columnId !== TABLE_COLUMNS.DIFFERENCE) {
    return {};
  }

  return {
    color: value === 0 ? COLORS.GREEN : COLORS.RED,
    fontSize: pageType === PAGE_TYPE.PRINT ? "20px" : "30px",
  };
};

export const getStylesForDifferenceDetailedColumnCell = ({
  columnId,
  pageType,
  value,
}) => {
  if (columnId !== TABLE_COLUMNS.DIFFERENCE) {
    return {};
  }

  return {
    borderRadius: "12px",
    backgroundColor: value === 0 ? COLORS.GREEN : COLORS.RED,
    color: "#ffffff",
    display: "grid",
    fontSize: "12px",
    fontWeight: "500",
    height: "24px",
    placeContent: "center",
    width: "53px",
  };
};

export const extractDetailedAppValue = ({ columnId, columnField, data, t }) => {
  if (columnId === TABLE_COLUMNS.CATEGORY) {
    return data[columnField].Nome;
  }

  if (columnId === TABLE_COLUMNS.ORIGIN) {
    return t("common:application");
  }

  if (COLUMNS_WITHOUT_PORTAL_DATA.includes(columnId)) {
    return data[columnField];
  }

  return data[columnField].App;
};

export const extractDetailedPortalValue = ({
  columnId,
  columnField,
  data,
  t,
}) => {
  if (columnId === TABLE_COLUMNS.ORIGIN) {
    return t("common:portal");
  }

  if (
    [...COLUMNS_WITHOUT_PORTAL_DATA, TABLE_COLUMNS.CATEGORY].includes(columnId)
  ) {
    return null;
  }

  return data[columnField].Portal;
};
